export default {
  common: {
    searchField: 'Search field',
    relationQuery: 'Related term search',
    pageName: 'Page name',
    edition: 'Edition',
    issueNumber: 'Issue number',
    sourceField: 'Source',
    column: 'Column',
    paperName: 'Publication',
    layoutType: 'Layout type',
    normalLayout: 'Normal',
    jointLayout: 'Joint layout',
    traditionalSwitch: 'Traditional Chinese',
    simplified: 'Simplified',
    traditional: 'Traditional',
    sameWord: 'Synonym expansion',
    oppositeWord: 'Antonym expansion',
    dateSort: 'Date sort',
    contentFilter: 'Content filter',
    ascending: 'Ascending',
    descending: 'Descending',
    relatedness: 'Relevance',
    title: 'Title',
    author: 'Author',
    content: 'Content',
    body: 'Body',
    titleContent: 'Title + content',
    aiSummary: 'AI summary',
    default: 'Default',
    articleClassification: 'Article category',
    articleGenre: 'Article genre',
    region: 'Region',
    person: 'Person',
    headline: 'Headline',
    editorName: 'Editor name',
    publicStatus: 'Public status',
    genreMessage: 'News',
    genreCommunication: 'Feature',
    genreEditorial: 'Editorial',
    genreCommentary: 'Commentary',
    genreSpeech: 'Speech',
    genreTheoreticalArticle: 'Theoretical article',
    genreLetter: 'Letter',
    genreCommunique: 'Communique',
    genreAnnouncement: 'Announcement',
    genreSupplement: 'Supplement article',
    genreInterview: 'Interview',
    genreImagePromotion: 'Image promotion',
    other: 'Other',
    vectorKeyword: 'Keywords',
    vectorKeywordPlaceholder: 'Enter keywords or import an image',
    vectorKeywordRequired: 'Enter keywords',
    vectorKeywordOrImageRequired: 'Enter keywords or import an image',
    similarCount: 'Similar results',
    importImage: 'Import image',
    imageImportedPreview: 'Image imported. Click to preview',
    clearImage: 'Clear image',
    imageOnly: 'Only image files can be uploaded',
    selectCategoryTitle: 'Select category',
    selectAiCategoryTitle: 'Select AI category',
    filterCategoryPlaceholder: 'Filter by keyword'
  }
}
